// Text for the Internal system settings screen (Internal → System → Einstellungen)
import { TERMS } from './terms'

export const SYSTEM_SETTINGS = {
  saved: 'Einstellungen gespeichert',
  matching: {
    robotDescription:
      'Der Matching Robot gleicht automatisch Suchaufträge mit Immobilien ab',
  },

  hubspot: {
    title: 'HubSpot / Matching',
    subtitle: 'Datenabgleich und Matching Robot',
    pipelineStage: {
      title: 'Pipeline-Status',
      subtitle:
        'Schreibt Status-Änderungen der Suchaufträge zurück nach HubSpot',
    },
    nightlySync: {
      title: 'Automatischer Abgleich',
      subtitle: 'Gleicht alle Suchauftrags-Status regelmäßig mit HubSpot ab',
      updated: 'Aktualisiert',
      skipped: 'Übersprungen',
      triggerSuccess: (updated: number) =>
        `Sync abgeschlossen: ${updated} aktualisiert`,
      triggerError: 'Sync fehlgeschlagen',
    },
    staffDirectory: {
      title: 'Berater-Cache',
      subtitle:
        'Lädt Namen, Telefonnummern und Buchungslinks der Berater vorab aus HubSpot',
      running: 'Lädt…',
      staffCount: 'Berater im Cache',
      triggerSuccess: (staffCount: number) =>
        `${staffCount} Berater aus HubSpot geladen`,
      triggerPartial:
        'HubSpot nicht erreichbar — der bisherige Stand bleibt aktiv',
    },
  },

  email: {
    title: TERMS.email,
    description: 'Konfiguration für den E-Mail-Versand',
    sendingLabel: 'E-Mail-Versand',
    sendingDescription:
      'Aktiviert oder deaktiviert den globalen E-Mail-Versand',
    robotLabel: 'E-Mail-Robot',
    robotDescription:
      'Der E-Mail-Robot versendet automatisch Benachrichtigungen zu bestätigten Matches',
    intervalLabel: 'Robot-Mailing-Intervall',
    intervalDescription: 'Zeitintervall zwischen den Robot-Mailing-Durchläufen',
    intervalEditTitle: 'Robot-Mailing-Intervall bearbeiten',
    intervalValidation: 'Muss mindestens 1 Minute sein',
  },

  advisor: {
    title: 'Standard-Ansprechpartner',
    description:
      'Wird angezeigt, wenn kein persönlicher Berater hinterlegt ist',
    label: TERMS.contactPerson,
    none: 'Kein Standard',
    hint: `Gilt im öffentlichen ${TERMS.configurator} und auf Projektseiten ohne ${TERMS.advisor}`,
    saved: 'Standard-Ansprechpartner aktualisiert',
  },
} as const
